import { defineTokens } from '@chakra-ui/react/styled-system';

const fontSizes = defineTokens.fontSizes({
  '1': {
    value: '0.75rem',
  },
  '2': {
    value: '0.875rem',
  },
  '3': {
    value: '1rem',
  },
  '4': {
    value: '1.1875rem',
  },
  '5': {
    value: '1.5rem',
  },
  '6': {
    value: '1.875rem',
  },
  '7': {
    value: '2.25rem',
  },
  '8': {
    value: '3rem',
  },
  base: {
    value: '1rem',
  },
});

export default fontSizes;
